/**
 * 체험단 캠페인 레이아웃 라우트
 *
 * 하위 라우트($campaignId)를 렌더링하는 레이아웃 전용.
 * 목록 뷰 없이 캠페인 상세 페이지만 제공한다.
 */
import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/apply/$mallId/$shopNo')({
  component: SeedingCampaignLayout,
})

function SeedingCampaignLayout() {
  return <Outlet />
}
